<h3 class="fw-bold">{{ title }}</h3>

<form [formGroup]="form" autocomplete="off">

  <div class="col-md-12">
    <div class="row">
      <div class="col-md-1 d-none d-md-flex"></div>
      <div class="col-md-11 col-12">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <mat-form-field class="material-form col-12" appearance="outline">
              <mat-label>Search Combination</mat-label>
              <mat-select formControlName="searchCombinationType" #searchCombinationTypeInput>
                @for (data of searchCombinationTypeEnum | keys; track data) {
                  <mat-option [value]="data">{{ data }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>

    </div>

  </div>

  <ng-container formArrayName="searchFields">
    @for (item of getSearchFieldArray.controls; track item; let i = $index) {
      <ng-container [formGroupName]="i">
        <div class="row my-3">
          <div class="col-md-1 d-none d-md-flex align-items-center justify-content-center">
            <div class="bg-primary text-white rounded-4 search-number">
              <span>{{ i + 1 }}</span>
            </div>
          </div>
          <div class="col-md-11 col-12">
            <div class="row">
              <div class="col-md-6">
                <mat-form-field class="col-12" appearance="outline">
                  <mat-label>Field Name</mat-label>
                  <mat-select #columnSelect formControlName="fieldName">
                    @if (searchFields) {
                      <!--                    <mat-option>-->
                      <!--                      <ngx-mat-select-search (ngModelChange)="onSearch($event)" [clearSearchInput]="false"-->
                      <!--                                             [formControl]="roleFilterCtrl"-->
                      <!--                                             noEntriesFoundLabel="No matching Field found"-->
                      <!--                                             placeholderLabel="Select Field ...">-->
                    <!--                      </ngx-mat-select-search>-->
                  <!--                    </mat-option>-->
                  @for (data of searchFields; track data) {
                    <mat-option [value]="data?.fieldName">  {{ data?.fieldName }}</mat-option>
                  }
                }
              </mat-select>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field class="material-form col-12" appearance="outline">
              <mat-label>Search Type</mat-label>
              <mat-select formControlName="searchType" required #searchType>
                @for (data of searchOperationType | keys; track data) {
                  <mat-option [value]="data">{{ data }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          @if (searchType.value !== searchOperationType.Between && searchType.value !== searchOperationType.IsNotNull && searchType.value !== searchOperationType.IsNull) {
            <div class="col-md-8">
              <mat-form-field class="material-form col-12" appearance="outline">
                <mat-label>Search Value</mat-label>
                <textarea formControlName="fieldValue" matInput rows="1" required maxlength="250" #textAreaLimit></textarea>
                <mat-hint align="end">{{ textAreaLimit?.value?.length }}/250</mat-hint>
              </mat-form-field>
            </div>
          }
          @if (searchType.value === searchOperationType.Between) {
            <div class="col-md-4">
              <mat-form-field class="material-form col-12" appearance="outline">
                <mat-label>First Search Value</mat-label>
                <input formControlName="fieldValueOne" matInput required>
              </mat-form-field>
            </div>
            <div class="col-md-4">
              <mat-form-field class="material-form col-12" appearance="outline">
                <mat-label>Second Search Value</mat-label>
                <input formControlName="fieldValueTwo" matInput required>
              </mat-form-field>
            </div>
          }
          <div class="col-md-4 pt-2">
            @if (getSearchFieldArray.controls.length == (i+1)) {
              <button (click)="addSearchField(null)" class="mx-1 text-white" color="primary" mat-icon-button matTooltip="Add More" type="button">
                <mat-icon>add</mat-icon>
              </button>
            }
            <button (click)="removeSearchField(i)" color="accent" mat-icon-button matTooltip="Remove" type="button">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="col-12"><hr></div>
        </div>
      </div>
    </div>
  </ng-container>
}
</ng-container>

</form>

<div mat-dialog-actions class="d-flex justify-content-end">
  <button mat-button mat-dialog-close>Close</button>
  <button mat-button [mat-dialog-close]="modifiedValues(getSearchFieldArray.value, searchCombinationTypeInput.value)">Search</button>
</div>
